module.exports = __webpack_public_path__ + "img/ins.b698a2a4.png";